<template>
  <v-container style="overflow: auto; min-height: 700px; max-height: 700px;">
    <v-row class="pt-10 px-4" justify="center">
      <v-col cols="12" align="center">
        <span class="w-700 font-18 text-333333">แบบบันทึกการเยี่ยมบ้าน รายบุคคล คลินิกการพยาบาลและการผดุงครรภ์</span>
      </v-col>
    </v-row>
    <v-form ref="form2">
      <v-row class="px-4" justify="center">
        <v-col cols="12" xl="8" lg="8" md="8" sm="8" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">ชื่อโรงพยาบาล/คลินิก</span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกชื่อคลินิก" color="#00A99D"
              v-model="clinic_name" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="px-4 pb-4">
        <v-col cols="12" xl="6" lg="5" md="4" sm="4" class="py-0">
          <span class="font-16 w-700 text-333333">ข้อมูลทั่วไป </span>
        </v-col>
        <v-col cols="12" xl="6" lg="7" md="8" sm="8" class="py-0 d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">Authentication Code <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอก Authentication Code" color="#00A99D"
              v-model="Authentication_code" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="5" md="5" lg="6" xl="6" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">ชื่อ-สกุล</span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกชื่อ-สกุล" color="#00A99D"
              v-model="general_info.fullname" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="2" xl="2" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">เพศ</span>
          <v-row no-gutters>
            <v-checkbox hide-details="auto" dense v-model="general_info.gender" color="#00A99D" value="ชาย"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="pr-5 text-313B41 w-500 font-16">ชาย</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense v-model="general_info.gender" color="#00A99D" value="หญิง"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-313B41 w-500 font-16">หญิง</span>
              </template>
            </v-checkbox>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">วัน/เดือน/ปีเกิด</span>
          <v-row no-gutters>
            <v-menu ref="birth_date" v-model="menubirth_date" :close-on-content-click="false"
              :return-value.sync="general_info.birth_date" transition="scale-transition" offset-y min-width="auto"
              bottom right hide-details="auto" :disabled="status == 'see'">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field placeholder="วัน/เดือน/ปีเกิด" solo dense :value="formatBirthDate"
                  append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" required
                  color="#00A99D" item-color="teal darken-2">
                  <template slot="append">
                    <v-btn text icon v-on="on" :readonly="status == 'see'">
                      <v-icon color="#00A99D">mdi-calendar</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker ref="picker" v-model="general_info.birth_date" no-title scrollable :max="yearmax"
                locale="th" @input="calculateAge(general_info.birth_date)" color="#00A99D" :readonly="status == 'see'">
                <v-spacer></v-spacer>
                <v-btn text color="#00A99D" @click="cancel_birth()">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">เชื้อชาติ <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" color="#00A99D" placeholder="กรุณากรอกเชื้อชาติ"
              v-model="general_info.race" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">สัญชาติ <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" color="#00A99D" placeholder="กรุณากรอกสัญชาติ"
              v-model="general_info.nationality" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">เลขบัตรประจำตัวประชาชน</span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน" color="#00A99D"
              v-model="card_num_display" v-mask="mask_id" :rules="status == 'see' ? [] : rules_detail_cid"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">รหัสโรคหลัก <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกรหัสโรคหลัก" color="#00A99D"
              v-model="general_info.primary_disease_code" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">รหัสโรครอง <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกรหัสโรครอง" color="#00A99D"
              v-model="general_info.secondary_disease_code" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-6 pt-2 font-16 w-700 text-333333">สิทธิการรักษาพยาบาล <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.medical_right.status"
              color="#00A99D" value="1"
              @change="general_info.medical_right.title = 'ประกันสุขภาพถ้วนหน้า (30 บาท)', general_info.medical_right.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-313B41 w-500 font-16">ประกันสุขภาพถ้วนหน้า (30 บาท)</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.medical_right.status"
              color="#00A99D" value="2"
              @click="general_info.medical_right.title = 'ประกันสังคม', general_info.medical_right.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-313B41 w-500 font-16">ประกันสังคม</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.medical_right.status"
              color="#00A99D" value="3"
              @click="general_info.medical_right.title = 'ข้าราชการ / รัฐวิสาหกิจ', general_info.medical_right.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-313B41 w-500 font-16">ข้าราชการ / รัฐวิสาหกิจ</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.medical_right.status"
              color="#00A99D" value="4"
              @click="general_info.medical_right.title = 'อื่น ๆ', general_info.medical_right.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-313B41 w-500 font-16">อื่น ๆ</span>
              </template>
            </v-checkbox>
            <v-text-field v-if="general_info.medical_right.status === '4'" dense solo hide-details="auto"
              placeholder="กรุณาระบุสิทธิการรักษาพยาบาล อื่น ๆ" color="#00A99D"
              v-model="general_info.medical_right.detail" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333" style="white-space: nowrap;">ที่อยู่ (ตามบัตรประชาชน)</span>
          <v-row no-gutters>
            <v-text-field
              v-if="general_info.officail_address !== '' && general_info.officail_address !== null && general_info.officail_address !== undefined"
              dense solo hide-details="auto" placeholder="กรุณากรอกที่อยู่ (ตามบัตรประชาชน)"
              v-model="general_info.officail_address" disabled></v-text-field>

            <v-card v-else class="pa-8">
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> บ้านเลขที่ <span class="red--text">*</span></span>
                    <v-text-field placeholder="บ้านเลขที่" solo hide-details="auto" dense
                      v-model="data_officail_address.house_no" @change="checkbox_addressable = false"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> หมู่ <span class="red--text">*</span></span>
                    <v-text-field placeholder="หมู่" solo hide-details="auto" v-model="data_officail_address.moo_no"
                      dense @change="checkbox_addressable = false" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> ถนน / ซอย </span>
                    <v-text-field placeholder="ถนน / ซอย" solo hide-details="auto" v-model="data_officail_address.soi"
                      dense @change="checkbox_addressable = false" :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> จังหวัด <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_province1" item-value="province" item-text="province"
                      @input="getProvince('officail_address'), getAmphoe('officail_address')"
                      @change="checkbox_addressable = false" :menu-props="{ bottom: true, offsetY: true }" solo dense
                      hide-details="auto" placeholder="กรุณาเลือกจังหวัด" v-model="data_officail_address.province"
                      item-color="teal darken-2" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> อำเภอ / เขต <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_amphoe1" item-value="amphoe" item-text="amphoe"
                      @input="getTambon('officail_address')" @change="checkbox_addressable = false"
                      :menu-props="{ bottom: true, offsetY: true }" solo dense hide-details="auto"
                      placeholder="กรุณาเลือกอำเภอ/เขต" v-model="data_officail_address.amphur"
                      item-color="teal darken-2" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> ตำบล / แขวง <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_tambon1" item-value="tambon" item-text="tambon"
                      @change="getPostal($event, 'officail_address'), checkbox_addressable = false"
                      :menu-props="{ bottom: true, offsetY: true }" solo dense hide-details="auto"
                      placeholder="กรุณาเลือกตำบล/แขวง" v-model="data_officail_address.tambon"
                      item-color="teal darken-2" color="#00A99D" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกอำเภอ</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333">รหัสไปรษณีย์ <span class="red--text">*</span></span>
                    <v-text-field placeholder="รหัสไปรษณีย์" solo hide-details="auto"
                      v-model="data_officail_address.zipcode" dense @change="checkbox_addressable = false"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </v-col>
        <v-row class="px-5 py-3">
          <v-spacer></v-spacer>
          <v-tooltip v-if="general_info.addressable !== '' && edit == false" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mr-2" fab small text depressed @click="edit = true">
                <v-icon size="24" color="#00A99D">mdi-pen</v-icon>
              </v-btn>
            </template>
            <span>แก้ไข</span>
          </v-tooltip>
          <v-checkbox v-else-if="general_info.addressable == '' || (general_info.addressable !== '' && edit == true)"
            hide-details="auto" v-model="checkbox_addressable" label="ที่อยู่ตามบัตรประชาชน" color="#00A99D"
            @click="showAddressable()"
            :readonly="status == 'see' && general_info.officail_address == '' && (data_officail_address.house_no == '' || data_officail_address.tambon == '' || data_officail_address.amphur == '' || data_officail_address.province == '' || data_officail_address.zipcode == '') || status == 'see'"></v-checkbox>
        </v-row>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333" style="white-space: nowrap;">ที่อยู่
            (ที่สามารถติดต่อได้)</span>
          <v-row no-gutters>
            <v-text-field
              v-if="(checkbox_addressable == true && general_info.officail_address !== '' && general_info.officail_address !== null && general_info.officail_address !== undefined) || (checkbox_addressable == false && general_info.addressable !== '' && edit == false)"
              dense solo hide-details="auto" placeholder="กรุณากรอกที่อยู่ (ที่สามารถติดต่อได้)"
              v-model="general_info.addressable"
              :disabled="checkbox_addressable == true || (general_info.addressable !== '' && edit == false)"></v-text-field>

            <v-card class="pa-8"
              v-else-if="(checkbox_addressable == false && general_info.officail_address !== '' && general_info.officail_address !== null && general_info.officail_address !== undefined) || (general_info.officail_address == '' || general_info.officail_address == null || general_info.officail_address == undefined) || (general_info.addressable !== '' && edit == true)">
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> บ้านเลขที่ <span class="red--text">*</span></span>
                    <v-text-field placeholder="บ้านเลขที่" solo hide-details="auto" dense
                      v-model="data_addressable.house_no" :disabled="checkbox_addressable == true"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="2" lg="2" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> หมู่ <span class="red--text">*</span></span>
                    <v-text-field placeholder="หมู่" solo hide-details="auto" v-model="data_addressable.moo_no" dense
                      :disabled="checkbox_addressable == true" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> ถนน / ซอย </span>
                    <v-text-field placeholder="ถนน / ซอย" solo hide-details="auto" v-model="data_addressable.soi" dense
                      :disabled="checkbox_addressable == true" :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> จังหวัด <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_province" item-value="province" item-text="province"
                      @input="getProvince('addressable'), getAmphoe('addressable')"
                      :menu-props="{ bottom: true, offsetY: true }" solo dense hide-details="auto"
                      placeholder="กรุณาเลือกจังหวัด" v-model="data_addressable.province" item-color="teal darken-2"
                      color="#00A99D" :disabled="checkbox_addressable == true"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> อำเภอ / เขต <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_amphoe" item-value="amphoe" item-text="amphoe"
                      @input="getTambon('addressable')" :menu-props="{ bottom: true, offsetY: true }" solo dense
                      hide-details="auto" placeholder="กรุณาเลือกอำเภอ/เขต" v-model="data_addressable.amphur"
                      item-color="teal darken-2" color="#00A99D" :disabled="checkbox_addressable == true"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333"> ตำบล / แขวง <span class="red--text">*</span></span>
                    <v-autocomplete :items="set_tambon" item-value="tambon" item-text="tambon"
                      @change="getPostal($event, 'addressable')" :menu-props="{ bottom: true, offsetY: true }" solo
                      dense hide-details="auto" placeholder="กรุณาเลือกตำบล/แขวง" v-model="data_addressable.tambon"
                      item-color="teal darken-2" color="#00A99D" :disabled="checkbox_addressable == true"
                      :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'">
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกอำเภอ</span>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="4" lg="4" class="pt-0">
                  <div class="d-flex flex-column">
                    <span class="text-333333">รหัสไปรษณีย์ <span class="red--text">*</span></span>
                    <v-text-field placeholder="รหัสไปรษณีย์" solo hide-details="auto" v-model="data_addressable.zipcode"
                      dense :disabled="checkbox_addressable == true" :rules="status == 'see' ? [] : rules_detail"
                      :readonly="status == 'see'"></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </v-col>
        <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">เบอร์โทรศัพท์ <span class="red--text">*</span></span>
          <v-text-field dense solo hide-details="auto" v-model="general_info.mobile"
            placeholder="กรุณากรอกเบอร์โทรศัพท์" v-mask="[mask_mobile1, mask_mobile2]" @input="splitDat2('mobile')"
            :rules="status == 'see' ? [] : rules_detail_mobile" :readonly="status == 'see'"></v-text-field>
        </v-col>
        <v-col lg="8" xl="8"></v-col>
        <v-col cols="12" sm="8" md="8" lg="8" xl="8">
          <v-row no-gutters>
            <span class="pr-3 pt-2 font-16 w-700 text-333333">ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ ชื่อ-สกุล <span
                class="red--text">*</span></span>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกชื่อ-สกุล"
              v-model="general_info.emergency_contact_name" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 font-16 w-700 text-333333">เบอร์โทรศัพท์ <span class="red--text">*</span></span>
          <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกเบอร์โทรศัพท์"
            v-model="general_info.emergency_contact_mobile" v-mask="[mask_mobile1, mask_mobile2]"
            @input="splitDat2('mobile2')" :rules="status == 'see' ? [] : rules_detail_mobile"
            :readonly="status == 'see'"></v-text-field>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-6 pt-2 font-16 w-700 text-333333">สถานภาพ <span class="red--text">*</span></span>
          <v-row no-gutters>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.status_profile.status"
              color="#00A99D" value="1"
              @click="general_info.status_profile.title = 'โสด', general_info.status_profile.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-333333 w-500 font-16">โสด</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.status_profile.status"
              color="#00A99D" value="2"
              @click="general_info.status_profile.title = 'สมรส', general_info.status_profile.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-333333 w-500 font-16">สมรส</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.status_profile.status"
              color="#00A99D" value="3"
              @click="general_info.status_profile.title = 'หม้าย', general_info.status_profile.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-333333 w-500 font-16">หม้าย</span>
              </template>
            </v-checkbox>
            <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.status_profile.status"
              color="#00A99D" value="4"
              @click="general_info.status_profile.title = 'อื่น ๆ', general_info.status_profile.detail = ''"
              :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
              <template v-slot:label>
                <span class="text-333333 w-500 font-16">อื่น ๆ</span>
              </template>
            </v-checkbox>
            <v-row no-gutters v-if="general_info.status_profile.status == '4'">
              <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุสถานภาพ อื่น ๆ" color="#00A99D"
                v-model="general_info.status_profile.detail" :rules="status == 'see' ? [] : rules_detail"
                :readonly="status == 'see'"></v-text-field>
            </v-row>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters class="d-flex d-flex-row">
            <span class="pr-3 pt-2 w-700 font-16 text-333333">ประเภทผู้ป่วย</span>
            <v-col cols="11" xl="11" lg="11" md="10" sm="10" class="pt-1">
              <v-row>
                <v-col cols="12">
                  <v-checkbox hide-details="auto" v-model="general_info.patient_type.status" color="#00A99D" value="1"
                    dense class="mt-0 set-checkbox" :rules="status == 'see' ? [] : rules_checkbox"
                    :readonly="status == 'see'"
                    @click="general_info.patient_type.id = '7001', general_info.patient_type.title = 'กลุ่มผู้ป่วยที่สามารถรักษาหายได้ ได้แก่ กลุ่มผู้รับบริการที่มีการเจ็บป่วยด้วยโรคที่ไม่รุนแรงมาก ใช้เวลาในการดูแลเพียงช่วงระยะสั้น, หญิงตั้งครรภ์/หลังคลอดที่มีภาวะแทรกซ้อน เช่นครรภ์เป็นพิษ มีภาวะ Postpartum blue เป็นต้น, มารดาทารกหลังคลอดติดตามการเลี้ยงดูบุตร ส่งเสริมการเลี้ยงลูกด้วยนมแม่ เฝ้าระวังการเจริญเติบโต/พัฒนาการ การได้รับภูมิคุ้มกันโรคในเด็ก เป็นต้น'">
                    <template v-slot:label>
                      <span class="pr-5 text-333333 w-500 font-16 align-self-start">7001</span>
                      <span class="text-333333 w-500 font-16">กลุ่มผู้ป่วยที่สามารถรักษาหายได้ ได้แก่
                        กลุ่มผู้รับบริการที่มีการเจ็บป่วยด้วยโรคที่ไม่รุนแรงมาก ใช้เวลาในการดูแลเพียงช่วงระยะสั้น,
                        หญิงตั้งครรภ์/หลังคลอดที่มีภาวะแทรกซ้อน เช่นครรภ์เป็นพิษ มีภาวะ Postpartum blue เป็นต้น,
                        มารดาทารกหลังคลอดติดตามการเลี้ยงดูบุตร ส่งเสริมการเลี้ยงลูกด้วยนมแม่
                        เฝ้าระวังการเจริญเติบโต/พัฒนาการ การได้รับภูมิคุ้มกันโรคในเด็ก เป็นต้น</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox hide-details="auto" v-model="general_info.patient_type.status" color="#00A99D" value="2"
                    dense class="mt-0 set-checkbox" :rules="status == 'see' ? [] : rules_checkbox"
                    :readonly="status == 'see'"
                    @click="general_info.patient_type.id = '7002', general_info.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้ ได้แก่ ผู้ป่วยโรคเรื้อรังต่างๆ เช่นความดันโลหิตสูง เบาหวาน โรคเลือดบางชนิด ที่มีปัญหาในการปฏิบัติตน ขาดความรู้ในการดูแลตนเอง'">
                    <template v-slot:label>
                      <span class="pr-5 text-333333 w-500 font-16 align-self-start">7002</span>
                      <span class="text-333333 w-500 font-16">กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้ ได้แก่
                        ผู้ป่วยโรคเรื้อรังต่างๆ เช่นความดันโลหิตสูง เบาหวาน โรคเลือดบางชนิด ที่มีปัญหาในการปฏิบัติตน
                        ขาดความรู้ในการดูแลตนเอง</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox hide-details="auto" v-model="general_info.patient_type.status" color="#00A99D" value="3"
                    dense class="mt-0 set-checkbox" :rules="status == 'see' ? [] : rules_checkbox"
                    :readonly="status == 'see'"
                    @click="general_info.patient_type.id = '7003', general_info.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย ได้แก่ผู้ป่วยที่มีปัญหาในการทำกิจวัตรประจำวัน ต้องพึ่งอุปกรณ์ทางการแพทย์ เช่น ใส่ NG tube ล้างไตทางช่องท้อง (CAPD) เป็นต้น'">
                    <template v-slot:label>
                      <span class="pr-5 text-333333 w-500 font-16 align-self-start">7003</span>
                      <span class="text-333333 w-500 font-16">กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย
                        ได้แก่ผู้ป่วยที่มีปัญหาในการทำกิจวัตรประจำวัน ต้องพึ่งอุปกรณ์ทางการแพทย์ เช่น ใส่ NG tube
                        ล้างไตทางช่องท้อง (CAPD) เป็นต้น</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <span class="pr-3 pt-2 text-333333 font-16 w-700">ข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน <span
                class="red--text">*</span></span>
            <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน"
              v-model="general_info.home_visit_reason" :rules="status == 'see' ? [] : rules_detail"
              :readonly="status == 'see'"></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 text-333333 font-16 w-700">โรคประจำตัว <span class="red--text">*</span></span>
          <v-row>
            <v-col cols="12" lg="3" xl="2" md="3" sm="4" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.congenital_disease.status" color="#00A99D"
                  value="1" @click="general_info.congenital_disease.title = 'ไม่มี'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="text-333333 font-16 w-500">ไม่มี</span>
                  </template>
                </v-checkbox>
              </v-row>
            </v-col>
            <v-col cols="12" lg="9" xl="10" md="9" sm="8" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.congenital_disease.status" color="#00A99D"
                  value="2" @click="general_info.congenital_disease.title = 'มี'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">มี</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters v-if="general_info.congenital_disease.status == '2'">
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกโรคประจำตัว" color="#00A99D"
                    v-model="general_info.congenital_disease.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการรักษา <span class="red--text">*</span></span>
          <v-row>
            <v-col cols="12" lg="6" xl="6" md="6" sm="6" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.medical_history.hospital.status"
                  color="#00A99D" value="1" @click="general_info.medical_history.hospital.title = 'รักษาโรงพยาบาล'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">รักษาโรงพยาบาล</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters v-if="general_info.medical_history.hospital.status == '1'">
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกประวัติการรักษา" color="#00A99D"
                    v-model="general_info.medical_history.hospital.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" xl="6" md="6" sm="6" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.medical_history.hospital.status"
                  color="#00A99D" value="2" @click="general_info.medical_history.hospital.title = 'รักษาคลินิก'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">รักษาคลินิก</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters v-if="general_info.medical_history.hospital.status == '2'">
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกประวัติการรักษา" color="#00A99D"
                    v-model="general_info.medical_history.hospital.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" xl="6" md="6" sm="6" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.medical_history.surgery.status"
                  color="#00A99D" value="1"
                  @click="general_info.medical_history.surgery.title = 'ไม่เคยผ่าตัด', general_info.medical_history.surgery.detail = ''"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">ไม่เคยผ่าตัด</span>
                  </template>
                </v-checkbox>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" xl="6" md="6" sm="6" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.medical_history.surgery.status"
                  color="#00A99D" value="2" @click="general_info.medical_history.surgery.title = 'เคยผ่าตัด'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">เคยผ่าตัด</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters v-if="general_info.medical_history.surgery.status == '2'">
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกประวัติการผ่าตัด" color="#00A99D"
                    v-model="general_info.medical_history.surgery.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการแพ้ยา <span class="red--text">*</span></span>
          <v-row>
            <v-col cols="12" lg="3" xl="2" md="3" sm="4" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.drug_allergy.status" color="#00A99D"
                  value="1" @click="general_info.drug_allergy.title = 'ปฏิเสธการแพ้ยา'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="text-333333 font-16 w-500">ปฏิเสธการแพ้ยา</span>
                  </template>
                </v-checkbox>
              </v-row>
            </v-col>
            <v-col cols="12" lg="9" xl="10" md="9" sm="8" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.drug_allergy.status" color="#00A99D"
                  value="2" @click="general_info.drug_allergy.title = 'แพ้ยา'"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">แพ้ยา</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters v-if="general_info.drug_allergy.status == '2'">
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกประวัติการแพ้ยา" color="#00A99D"
                    v-model="general_info.drug_allergy.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการแพ้อาหาร <span class="red--text">*</span></span>
          <v-row>
            <v-col cols="12" lg="3" xl="2" md="3" sm="4" class="d-flex d-flex-row">
              <v-checkbox hide-details="auto" dense v-model="general_info.food_allergies.status" color="#00A99D"
                value="1" @click="general_info.food_allergies.title = 'ปฏิเสธการแพ้อาหาร'"
                :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                <template v-slot:label>
                  <span class="pr-3 text-333333 font-16 w-500">ปฏิเสธการแพ้อาหาร</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" lg="9" xl="10" md="9" sm="8" class="d-flex d-flex-row">
              <v-checkbox hide-details="auto" dense v-model="general_info.food_allergies.status" color="#00A99D"
                value="2" @click="general_info.food_allergies.title = 'แพ้อาหาร'"
                :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                <template v-slot:label>
                  <span class="pr-3 text-333333 font-16 w-500">แพ้อาหาร</span>
                </template>
              </v-checkbox>
              <v-row no-gutters v-if="general_info.food_allergies.status == '2'">
                <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอกประวัติการแพ้อาหาร" color="#00A99D"
                  v-model="general_info.food_allergies.detail" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'"></v-text-field>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pr-6 pt-2 text-333333 font-16 w-700">ประเมินสมรรถนะผู้ป่วย <span
              class="red--text">*</span></span>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex d-flex-row">
              <v-checkbox hide-details="auto" dense class="pr-6" v-model="general_info.patient_performance.status"
                color="#00A99D" value="1"
                @click="general_info.patient_performance.title = 'ช่วยเหลือตนเองได้', general_info.patient_performance.detail = ''"
                :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                <template v-slot:label>
                  <span class="text-333333 font-16 w-500">ช่วยเหลือตนเองได้</span>
                </template>
              </v-checkbox>
              <v-checkbox hide-details="auto" dense v-model="general_info.patient_performance.status" color="#00A99D"
                value="2"
                @click="general_info.patient_performance.title = 'ช่วยเหลือตนเองไม่ได้', general_info.patient_performance.detail = ''"
                :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                <template v-slot:label>
                  <span class="text-333333 font-16 w-500">ช่วยเหลือตนเองไม่ได้</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="d-flex d-flex-row">
              <v-row no-gutters>
                <v-checkbox hide-details="auto" dense v-model="general_info.patient_performance.status" color="#00A99D"
                  value="3"
                  @click="general_info.patient_performance.title = 'ต้องใช้อุปกรณ์ช่วย', general_info.patient_performance.detail = ''"
                  :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
                  <template v-slot:label>
                    <span class="pr-3 text-333333 font-16 w-500">ต้องใช้อุปกรณ์ช่วย</span>
                  </template>
                </v-checkbox>
                <v-row no-gutters class="d-flex d-flex-row" v-if="general_info.patient_performance.status == '3'">
                  <span class="pr-3 pt-2 text-333333 font-16 w-500">ระบุ</span>
                  <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุข้อมูล" color="#00A99D"
                    v-model="general_info.patient_performance.detail" :rules="status == 'see' ? [] : rules_detail"
                    :readonly="status == 'see'"></v-text-field>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <span class="pr-6 pt-2 text-333333 font-16 w-700">Problem list โรค / ปัญหาที่พบ</span>
          <v-row class="pr-3 pb-2">
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="aad_list()" icon>
                  <v-icon color="#00A99D">mdi-plus-box</v-icon>
                </v-btn>
              </template>
              <span>เพิ่มข้อมูล</span>
            </v-tooltip>
          </v-row>
          <div style="min-height: 25vh; max-height: 200px;overflow-x: hidden;overflow-y: auto;">
            <v-row v-for="(item, index) in general_info.problem_list" :key="index" no-gutters
              class="py-2 pl-12 d-flex d-flex-row">
              <span class="pt-2 pr-3 font-16 text-333333">{{ index + 1 }}.</span>
              <v-text-field dense solo hide-details="auto" placeholder="กรุณากรอก Problem list โรค / ปัญหาที่พบ"
                color="#00A99D" v-model="general_info.problem_list[index].detail" :readonly="status == 'see'"
                @keypress="validateSpaceBar"></v-text-field>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="delete_list(index)" icon>
                    <v-icon color="#F5222D">mdi-minus-box</v-icon>
                  </v-btn>
                </template>
                <span>ลบข้อมูล</span>
              </v-tooltip>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import functioncryto from "@/services/encrypt.js";
import moment from "moment";

export default {
  props: ['status', 'data3'],
  data() {
    return {
      mask_id: 'X-XXXX-X####-##-#',
      mask_mobile1: '###-###-####',
      mask_mobile2: '#-####-####',
      dialog: false,
      checkbox_addressable: false,
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      set_province1: [],
      set_amphoe1: [],
      set_tambon1: [],
      data_officail_address: {
        house_no: "",
        moo_no: "",
        soi: "",
        tambon: "",
        amphur: "",
        province: "",
        zipcode: "",
        address: ""
      },

      data_addressable: {
        house_no: "",
        moo_no: "",
        soi: "",
        tambon: "",
        amphur: "",
        province: "",
        zipcode: "",
        address: ""
      },

      //แบบบันทึกการเยี่ยมบ้าน รายบุคคล คลินิกการพยาบาลและการผดุงครรภ์
      menubirth_date: false,
      yearmax: moment().format("YYYY-MM-DD"),

      clinic_name: sessionStorage.getItem('biz_name'), //ชื่อ คลินิก
      Authentication_code: "",
      general_info: { //ข้อมูลทั่วไป
        fullname: "",
        gender: "",
        birth_date: moment().format("YYYY-MM-DD"),
        race: "", //เชื้อชาติ
        nationality: "", //สัญชาติ
        card_num: "", //เลขบัตรประจ้าตัวประชาชน
        primary_disease_code: '', //รหัสโรคหลัก
        secondary_disease_code: '', //รหัสโรครอง
        medical_right: { //สิทธิการรักษาพยาบาล
          status: "",
          detail: "",
          title: ""
        },
        officail_address: "", //ที่อยู่ (ตามบัตรประชาชน)
        addressable: "", //ที่อยู่ (ที่สามารถติดต่อได้)
        mobile: "",
        emergency_contact_mobile: "", //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้เบอร์โทรศัพท
        emergency_contact_name: "", //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ชื่อ-สกุล
        status_profile:
        { //สถานภาพ
          status: "",
          detail: "",
          title: ""
        },
        patient_type: {
          status: '',
          id: '',
          title: ''
        },
        home_visit_reason: "", //ข้อบ่งชี้ เหตุผลในการเยี่ยมบ้าน
        congenital_disease: {
          status: "",
          detail: "",
          title: ""
        },
        medical_history: { //ประวัติการรักษา
          hospital: {
            status: "",
            detail: "",
            title: ""
          },
          surgery: {
            status: "",
            detail: "",
            title: ""
          }
        },
        drug_allergy: { //ประวัติการแพ้ยา
          status: "",
          detail: "",
          title: ""
        },
        food_allergies: { //ประวัติการแพ้อาหาร
          status: "",
          detail: "",
          title: ""
        },
        patient_performance: { //ประเมินสมรรถนะผู้ป่วย
          status: "",
          detail: "",
          title: ""
        },
        problem_list: [ //โรค ปัญหาที่พบ
          {
            id: 1,
            detail: ""
          },
          {
            id: 2,
            detail: ""
          },
          {
            id: 3,
            detail: ""
          }
        ],
      },
      edit: false,
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_detail: [
        (v) => !!v || "กรุณาระบุข้อมูล",
        (v) => !/^\s+|\s+$/.test(v) || "ห้ามมีช่องว่างหน้าหรือหลังข้อความ", // ห้ามมีช่องว่างหน้าหรือหลังข้อความ
        (v) => !/\s{2,}/.test(v) || "ห้ามมีช่องว่างซ้ำกัน", // ห้ามมีช่องว่างซ้ำกัน
      ],
      rules_detail_cid: [
        (v) => v.length != 0 || "กรุณากรอกเลขบัตรประจำตัวประชาชน",
        (v) => v.length === 17 || v.length === 0 || "กรุณากรอกให้ครบ 13 หลัก",
      ],
      rules_detail_mobile: [
        (v) => !!v || "กรุณากรอกเบอร์โทรศัพท์",
        (v) => v.length === 11 || v.length === 12 || "กรุณากรอกให้ครบ 9-10 หลัก",
      ],
      card_num_display: "",
    }
  },
  computed: {
    formatBirthDate() {
      var year1 = "";
      var year2 = "";
      if (this.general_info.birth_date === undefined || this.general_info.birth_date === "")
        return "";
      year1 = moment(this.general_info.birth_date).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      return moment(this.general_info.birth_date).locale("th").format("DD/MM/" + year2);
    },
  },
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
    data3(val) {
      if (val.patient_type != undefined) {
        if (val.patient_type.status != '' && val.patient_type.id != '' && val.patient_type.title != '') {
          this.general_info.patient_type = {
            status: val.patient_type.status,
            id: val.patient_type.id
          }

          if (val.patient_type.id == '7001') {
            this.general_info.patient_type.title = 'กลุ่มผู้ป่วยที่สามารถรักษาหายได้ ได้แก่ กลุ่มผู้รับบริการที่มีการเจ็บป่วยด้วยโรคที่ไม่รุนแรงมาก ใช้เวลาในการดูแลเพียงช่วงระยะสั้น, หญิงตั้งครรภ์/หลังคลอดที่มีภาวะแทรกซ้อน เช่นครรภ์เป็นพิษ มีภาวะ Postpartum blue เป็นต้น, มารดาทารกหลังคลอดติดตามการเลี้ยงดูบุตร ส่งเสริมการเลี้ยงลูกด้วยนมแม่ เฝ้าระวังการเจริญเติบโต/พัฒนาการ การได้รับภูมิคุ้มกันโรคในเด็ก เป็นต้น'
          } else if (val.patient_type.id == '7002') {
            this.general_info.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังที่ไม่สามารถควบคุมอาการได้ ได้แก่ ผู้ป่วยโรคเรื้อรังต่างๆ เช่นความดันโลหิตสูง เบาหวาน โรคเลือดบางชนิด ที่มีปัญหาในการปฏิบัติตน ขาดความรู้ในการดูแลตนเอง'
          } else if (val.patient_type.id == '7003') {
            this.general_info.patient_type.title = 'กลุ่มผู้ป่วยโรคเรื้อรังและไร้ความสามารถเล็กน้อย ได้แก่ผู้ป่วยที่มีปัญหาในการทำกิจวัตรประจำวัน ต้องพึ่งอุปกรณ์ทางการแพทย์ เช่น ใส่ NG tube ล้างไตทางช่องท้อง (CAPD) เป็นต้น'
          }
        } else {
          this.general_info.patient_type = {
            id: '7001',
            status: '1',
            title: 'กลุ่มผู้ป่วยที่สามารถรักษาหายได้ ได้แก่ กลุ่มผู้รับบริการที่มีการเจ็บป่วยด้วยโรคที่ไม่รุนแรงมาก ใช้เวลาในการดูแลเพียงช่วงระยะสั้น, หญิงตั้งครรภ์/หลังคลอดที่มีภาวะแทรกซ้อน เช่นครรภ์เป็นพิษ มีภาวะ Postpartum blue เป็นต้น, มารดาทารกหลังคลอดติดตามการเลี้ยงดูบุตร ส่งเสริมการเลี้ยงลูกด้วยนมแม่ เฝ้าระวังการเจริญเติบโต/พัฒนาการ การได้รับภูมิคุ้มกันโรคในเด็ก เป็นต้น'
          }
        }
      }
    }
  },
  mounted() {
    this.checkbox_addressable = false
    this.getProvince('');
  },
  methods: {
    splitDat() {
      if (this.general_info.card_num.length == 17) {
        var x = this.general_info.card_num.split('-')
        this.general_info.card_num = x[0] + x[1] + x[2] + x[3] + x[4]
      }
    },
    splitDat2(type) {
      if (type == 'mobile') {
        if (this.general_info.mobile.length >= 11 && this.general_info.mobile.length <= 12) {
          var x = this.general_info.mobile.split('-')
          this.general_info.mobile = x[0] + x[1] + x[2]
        }
      } else if (type == 'mobile2') {
        if (this.general_info.emergency_contact_mobile.length >= 11 && this.general_info.emergency_contact_mobile.length <= 12) {
          var y = this.general_info.emergency_contact_mobile.split('-')
          this.general_info.emergency_contact_mobile = y[0] + y[1] + y[2]
        }
      }
    },
    async openPage(items, individual_home_visits) {
      this.mask_id = 'X-XXXX-X####-##-#'
      this.mask_mobile1 = '###-###-####'
      this.mask_mobile2 = '#-####-####'
      // console.log('item page record', item);
      // console.log('individual_home_visits page record', individual_home_visits);
      var item = JSON.parse(JSON.stringify(items))
      this.clinic_name = individual_home_visits !== null && 'clinic_name' in individual_home_visits && individual_home_visits.clinic_name !== '' && individual_home_visits.clinic_name !== null && individual_home_visits.clinic_name !== undefined ? individual_home_visits.clinic_name : `${sessionStorage.getItem('biz_name') || ''}`,
        this.Authentication_code = individual_home_visits !== null && 'authentication_code' in individual_home_visits && individual_home_visits.authentication_code !== '' && individual_home_visits.authentication_code !== null && individual_home_visits.authentication_code !== undefined ? individual_home_visits.authentication_code : '',
        this.general_info = { //ข้อมูลทั่วไป
          fullname: 'fullname' in item && item.fullname !== '' && item.fullname !== null && item.fullname !== undefined ? item.fullname : '',
          gender: 'gender' in item && item.gender !== '' && item.gender !== null && item.gender !== undefined ? item.gender : '',
          birth_date: 'birth_date' in item && item.birth_date !== '' && item.birth_date !== null && item.birth_date !== undefined ? item.birth_date : '',
          race: individual_home_visits !== null && 'general_info' in individual_home_visits && 'race' in individual_home_visits.general_info && individual_home_visits.general_info.race !== '' && individual_home_visits.general_info.race !== null && individual_home_visits.general_info.race !== undefined ? individual_home_visits.general_info.race : '', //เชื้อชาติ
          nationality: individual_home_visits !== null && 'general_info' in individual_home_visits && 'nationality' in individual_home_visits.general_info && individual_home_visits.general_info.nationality !== '' && individual_home_visits.general_info.nationality !== null && individual_home_visits.general_info.nationality !== undefined ? individual_home_visits.general_info.nationality : '', //สัญชาติ
          card_num: 'cid' in item && item.cid !== '' && item.cid !== null && item.cid !== undefined ? await this.showCID(item.cid) : '', //เลขบัตรประจ้าตัวประชาชน
          primary_disease_code: individual_home_visits !== null && 'general_info' in individual_home_visits && 'primary_disease_code' in individual_home_visits.general_info && individual_home_visits.general_info.primary_disease_code !== '' && individual_home_visits.general_info.primary_disease_code !== null && individual_home_visits.general_info.primary_disease_code !== undefined ? individual_home_visits.general_info.primary_disease_code : '',
          secondary_disease_code: individual_home_visits !== null && 'general_info' in individual_home_visits && 'secondary_disease_code' in individual_home_visits.general_info && individual_home_visits.general_info.secondary_disease_code !== '' && individual_home_visits.general_info.secondary_disease_code !== null && individual_home_visits.general_info.secondary_disease_code !== undefined ? individual_home_visits.general_info.secondary_disease_code : '',
          medical_right: { //สิทธิการรักษาพยาบาล
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.status !== '' && individual_home_visits.general_info.medical_right.status !== null && individual_home_visits.general_info.medical_right.status !== undefined ? individual_home_visits.general_info.medical_right.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.detail !== '' && individual_home_visits.general_info.medical_right.detail !== null && individual_home_visits.general_info.medical_right.detail !== undefined ? individual_home_visits.general_info.medical_right.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.title !== '' && individual_home_visits.general_info.medical_right.title !== null && individual_home_visits.general_info.medical_right.title !== undefined ? individual_home_visits.general_info.medical_right.title : '',
          },
          officail_address: individual_home_visits !== null && 'general_info' in individual_home_visits && 'officail_address' in individual_home_visits.general_info && individual_home_visits.general_info.officail_address !== '' && individual_home_visits.general_info.officail_address !== null && individual_home_visits.general_info.officail_address !== undefined ? individual_home_visits.general_info.officail_address : '',
          addressable: individual_home_visits !== null && 'general_info' in individual_home_visits && 'addressable' in individual_home_visits.general_info && individual_home_visits.general_info.addressable !== '' && individual_home_visits.general_info.addressable !== null && individual_home_visits.general_info.addressable !== undefined ? individual_home_visits.general_info.addressable : '', //ที่อยู่ (ที่สามารถติดต่อได้)
          mobile: individual_home_visits !== null && 'mobile' in item && item.mobile !== '' && item.mobile !== null && item.mobile !== undefined ? item.mobile : '',
          emergency_contact_mobile: individual_home_visits !== null && 'general_info' in individual_home_visits && 'emergency_contact_mobile' in individual_home_visits.general_info && individual_home_visits.general_info.emergency_contact_mobile !== '' && individual_home_visits.general_info.emergency_contact_mobile !== null && individual_home_visits.general_info.emergency_contact_mobile !== undefined ? individual_home_visits.general_info.emergency_contact_mobile : '', //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้เบอร์โทรศัพท
          emergency_contact_name: individual_home_visits !== null && 'general_info' in individual_home_visits && 'emergency_contact_name' in individual_home_visits.general_info && individual_home_visits.general_info.emergency_contact_name !== '' && individual_home_visits.general_info.emergency_contact_name !== null && individual_home_visits.general_info.emergency_contact_name !== undefined ? individual_home_visits.general_info.emergency_contact_name : '', //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ชื่อ-สกุล
          status_profile:
          { //สถานภาพ
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.status !== '' && individual_home_visits.general_info.status_profile.status !== null && individual_home_visits.general_info.status_profile.status !== undefined ? individual_home_visits.general_info.status_profile.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.detail !== '' && individual_home_visits.general_info.status_profile.detail !== null && individual_home_visits.general_info.status_profile.detail !== undefined ? individual_home_visits.general_info.status_profile.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.title !== '' && individual_home_visits.general_info.status_profile.title !== null && individual_home_visits.general_info.status_profile.title !== undefined ? individual_home_visits.general_info.status_profile.title : '',
          },
          patient_type: {
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.status !== '' && individual_home_visits.general_info.patient_type.status !== null && individual_home_visits.general_info.patient_type.status !== undefined ? individual_home_visits.general_info.patient_type.status : '',
            id: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'id' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.id !== '' && individual_home_visits.general_info.patient_type.id !== null && individual_home_visits.general_info.patient_type.id !== undefined ? individual_home_visits.general_info.patient_type.id : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.title !== '' && individual_home_visits.general_info.patient_type.title !== null && individual_home_visits.general_info.patient_type.title !== undefined ? individual_home_visits.general_info.patient_type.title : '',
          },
          home_visit_reason: individual_home_visits !== null && 'general_info' in individual_home_visits && 'home_visit_reason' in individual_home_visits.general_info && individual_home_visits.general_info.home_visit_reason !== '' && individual_home_visits.general_info.home_visit_reason !== null && individual_home_visits.general_info.home_visit_reason !== undefined ? individual_home_visits.general_info.home_visit_reason : '',
          congenital_disease: {
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.status !== '' && individual_home_visits.general_info.congenital_disease.status !== null && individual_home_visits.general_info.congenital_disease.status !== undefined ? individual_home_visits.general_info.congenital_disease.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.detail !== '' && individual_home_visits.general_info.congenital_disease.detail !== null && individual_home_visits.general_info.congenital_disease.detail !== undefined ? individual_home_visits.general_info.congenital_disease.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.title !== '' && individual_home_visits.general_info.congenital_disease.title !== null && individual_home_visits.general_info.congenital_disease.title !== undefined ? individual_home_visits.general_info.congenital_disease.title : '',
          },
          medical_history: { //ประวัติการรักษา
            hospital: {
              status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'status' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.status !== '' && individual_home_visits.general_info.medical_history.hospital.status !== null && individual_home_visits.general_info.medical_history.hospital.status !== undefined ? individual_home_visits.general_info.medical_history.hospital.status : '',
              detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'detail' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.detail !== '' && individual_home_visits.general_info.medical_history.hospital.detail !== null && individual_home_visits.general_info.medical_history.hospital.detail !== undefined ? individual_home_visits.general_info.medical_history.hospital.detail : '',
              title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'title' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.title !== '' && individual_home_visits.general_info.medical_history.hospital.title !== null && individual_home_visits.general_info.medical_history.hospital.title !== undefined ? individual_home_visits.general_info.medical_history.hospital.title : '',
            },
            surgery: {
              status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'status' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.status !== '' && individual_home_visits.general_info.medical_history.surgery.status !== null && individual_home_visits.general_info.medical_history.surgery.status !== undefined ? individual_home_visits.general_info.medical_history.surgery.status : '',
              detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'detail' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.detail !== '' && individual_home_visits.general_info.medical_history.surgery.detail !== null && individual_home_visits.general_info.medical_history.surgery.detail !== undefined ? individual_home_visits.general_info.medical_history.surgery.detail : '',
              title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'title' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.title !== '' && individual_home_visits.general_info.medical_history.surgery.title !== null && individual_home_visits.general_info.medical_history.surgery.title !== undefined ? individual_home_visits.general_info.medical_history.surgery.title : '',
            }
          },
          drug_allergy: { //ประวัติการแพ้ยา
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.status !== '' && individual_home_visits.general_info.drug_allergy.status !== null && individual_home_visits.general_info.drug_allergy.status !== undefined ? individual_home_visits.general_info.drug_allergy.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.detail !== '' && individual_home_visits.general_info.drug_allergy.detail !== null && individual_home_visits.general_info.drug_allergy.detail !== undefined ? individual_home_visits.general_info.drug_allergy.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.title !== '' && individual_home_visits.general_info.drug_allergy.title !== null && individual_home_visits.general_info.drug_allergy.title !== undefined ? individual_home_visits.general_info.drug_allergy.title : '',
          },
          food_allergies: { //ประวัติการแพ้อาหาร
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.status !== '' && individual_home_visits.general_info.food_allergies.status !== null && individual_home_visits.general_info.food_allergies.status !== undefined ? individual_home_visits.general_info.food_allergies.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.detail !== '' && individual_home_visits.general_info.food_allergies.detail !== null && individual_home_visits.general_info.food_allergies.detail !== undefined ? individual_home_visits.general_info.food_allergies.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.title !== '' && individual_home_visits.general_info.food_allergies.title !== null && individual_home_visits.general_info.food_allergies.title !== undefined ? individual_home_visits.general_info.food_allergies.title : '',
          },
          patient_performance: { //ประเมินสมรรถนะผู้ป่วย
            status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.status !== '' && individual_home_visits.general_info.patient_performance.status !== null && individual_home_visits.general_info.patient_performance.status !== undefined ? individual_home_visits.general_info.patient_performance.status : '',
            detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.detail !== '' && individual_home_visits.general_info.patient_performance.detail !== null && individual_home_visits.general_info.patient_performance.detail !== undefined ? individual_home_visits.general_info.patient_performance.detail : '',
            title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.title !== '' && individual_home_visits.general_info.patient_performance.title !== null && individual_home_visits.general_info.patient_performance.title !== undefined ? individual_home_visits.general_info.patient_performance.title : '',
          },
          problem_list: individual_home_visits !== null && 'general_info' in individual_home_visits && 'problem_list' in individual_home_visits.general_info && individual_home_visits.general_info.problem_list.length !== 0 && individual_home_visits.general_info.problem_list !== null && individual_home_visits.general_info.problem_list !== undefined ? individual_home_visits.general_info.problem_list : [{ id: 1, detail: "" }, { id: 2, detail: "" }, { id: 3, detail: "" }],
        }
      // ตั้งค่า เลขบัตรประจ้าตัวประชาชน=====================================================================
      this.card_num_display = await this.showCID(item.cid)
      if ('cid' in item && item.cid !== '' && item.cid !== null && item.cid !== undefined) {
        try {
          var cid = await this.showCID(item.cid)
          if (cid && cid.length == 13) {
            let text = cid;
            let cid1 = await text.slice(0, 1);
            let cid2 = await text.slice(1, 5);
            let cid3 = await text.slice(5, 10);
            let cid4 = await text.slice(10, 12);
            let cid5 = await text.slice(12, 13);
            let cid_display = cid1 + "-" + cid2 + "-" + cid3 + "-" + cid4 + "-" + cid5
            this.card_num_display = cid_display
          }
        } catch {
          this.card_num_display = await this.showCID(item.cid)
        }
      }
      // ======================================================================
      this.checkbox_addressable = false
      this.edit = false
      // await this.splitDat("open")
      await this.splitDat2('mobile')
      await this.splitDat2('mobile2')
      this.$refs.form2.resetValidation()
    },
    async showCID(item) {
      // const maskedDigits = "X".repeat(6);
      // const visibleDigits = functioncryto.decrypt(item).substring(6);
      // return maskedDigits + visibleDigits;
      const cid = await functioncryto.decrypt(item);
      return cid
    },
    async showAddressable() {
      if (this.checkbox_addressable == true) {
        if (this.general_info.officail_address == '') {
          if (this.data_officail_address.house_no == '' && this.data_officail_address.tambon == '' && this.data_officail_address.amphur == '' && this.data_officail_address.province == '' && this.data_officail_address.zipcode == '') {
            this.$swal({
              icon: "warning",
              title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลที่อยู่ตามบัตรประชาชน</span>",
              confirmButtonText: "ปิด",
              confirmButtonColor: "#00A99D",
              showConfirmButton: false,
            }).then(() => {
              this.checkbox_addressable = false
            })
          }
          else if (this.data_officail_address.house_no == '' || this.data_officail_address.tambon == '' || this.data_officail_address.amphur == '' || this.data_officail_address.province == '' || this.data_officail_address.zipcode == '') {
            this.$swal({
              icon: "warning",
              title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลที่อยู่ตามบัตรประชาชนให้ครบถ้วน</span>",
              confirmButtonText: "ปิด",
              confirmButtonColor: "#00A99D",
              showConfirmButton: false,
            }).then(() => {
              this.checkbox_addressable = false
            })
          } else {
            this.data_addressable = {
              house_no: this.data_officail_address.house_no,
              moo_no: this.data_officail_address.moo_no,
              soi: this.data_officail_address.soi,
              tambon: this.data_officail_address.tambon,
              amphur: this.data_officail_address.amphur,
              province: this.data_officail_address.province,
              zipcode: this.data_officail_address.zipcode,
            }
            this.getAmphoe('')
            this.getTambon('addressable')
          }
        } else {
          if (this.general_info.officail_address !== '' && this.general_info.officail_address !== null && this.general_info.officail_address !== undefined) {
            this.general_info.addressable = this.general_info.officail_address
          } else if (this.general_info.officail_address == '' || this.general_info.officail_address == null || this.general_info.officail_address == undefined) {

            this.data_addressable = {
              house_no: this.data_officail_address.house_no,
              moo_no: this.data_officail_address.moo_no,
              soi: this.data_officail_address.soi,
              tambon: this.data_officail_address.tambon,
              amphur: this.data_officail_address.amphur,
              province: this.data_officail_address.province,
              zipcode: this.data_officail_address.zipcode,
            }
            this.getAmphoe('')
            this.getTambon('addressable')
          }
        }
      }
    },
    async valid2(status) {
      console.log('valid2');
      var check_problem_list = []

      if (this.general_info.problem_list !== 0) {
        await this.general_info.problem_list.forEach(async (ele) => {
          if (ele.detail !== '') {
            await check_problem_list.push(ele)
          }
        })

        this.general_info.problem_list = check_problem_list || []
      }

      if (this.general_info.officail_address == '' || this.general_info.officail_address == null || this.general_info.officail_address == undefined) {
        this.general_info.officail_address = await this.sum_address(this.data_officail_address)
      }

      if (this.general_info.data_addressable == '' || this.general_info.data_addressable == null || this.general_info.data_addressable == undefined) {
        this.general_info.data_addressable = await this.sum_address(this.data_addressable)
      }

      if (this.general_info.addressable == '' || this.general_info.addressable == null || this.general_info.addressable == undefined) {
        this.general_info.addressable = await this.sum_address(this.general_info.addressable)
      }

      // if(this.general_info.card_num.length == 17) {

      //   var x = await this.general_info.card_num.split('-')
      //   var cid = x[0]+x[1]+x[2]+x[3]+x[4]
      //   console.log("true", cid);
      //   this.general_info.card_num = await functioncryto.encrypt(cid)
      //   console.log("true ->", this.general_info.card_num);
      // } else {
      //   console.log("false", this.general_info.card_num);
      //   this.general_info.card_num = await functioncryto.encrypt(this.general_info.card_num)
      //   console.log("false -> ", this.general_info.card_num);
      // }

      // ======

      if (this.card_num_display.length == 17) {

        var x = await this.card_num_display.split('-')
        var cid = x[0] + x[1] + x[2] + x[3] + x[4]
        this.general_info.card_num = await JSON.parse(JSON.stringify(functioncryto.encrypt(cid)))
      } else {
        this.general_info.card_num = await JSON.parse(JSON.stringify(functioncryto.encrypt(this.card_num_display)))
      }
      //======

      if (this.general_info.mobile.length == 12) {
        var y = this.general_info.mobile.split('-')
        this.general_info.mobile = y[0] + y[1] + y[2]
      } else if (this.general_info.mobile.length == 11) {
        var z = this.general_info.mobile.split('-')
        this.general_info.mobile = z[0] + z[1] + z[2]
      }

      var data2 = {
        clinic_name: this.clinic_name,
        Authentication_code: this.Authentication_code,
        general_info: this.general_info,
      }

      this.$emit('data2', data2)
      if (status == 'finish') {
        if (this.$refs.form2.validate()) {
          this.$emit('valid2', false)
        } else {
          this.$emit('valid2', true)
        }
      } else if (status == '2page') {
        if (this.$refs.form2.validate()) {
          this.$emit('valid2', false)
        } else {
          this.$emit('valid2', true)
        }
      }
      this.general_info.problem_list = check_problem_list.length !== 0 && check_problem_list !== null && check_problem_list !== undefined ? check_problem_list : [{ id: 1, detail: "" }, { id: 2, detail: "" }, { id: 3, detail: "" }]
    },
    calculateAge(date) {
      if (date) {
        this.menubirth_date = false;
        this.$refs.birth_date.save(date);
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.general_info.age = y.toString();
      }
    },
    cancel_birth() {
      this.menubirth_date = false;
      this.$refs.birth_date.save("");
    },
    aad_list() {
      if (this.status !== 'see') {
        this.general_info.problem_list.push({ id: this.general_info.problem_list.length + 1, detail: '', title: '' })
      }
    },
    delete_list(index) {
      if (this.status !== 'see') {
        if (this.general_info.problem_list.length === 1) {
          this.general_info.problem_list = [
            {
              id: this.general_info.problem_list.length,
              detail: ''
            }
          ]
        } else {
          this.general_info.problem_list.splice(index, 1);
        }
      }
    },
    async getProvince(text) {
      try {
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province`).then((res) => {
          if (res.data.result == "success") {
            if (text == "officail_address") {
              this.set_province1 = res.data.data;
            } else if (text == "addressable") {
              this.set_province = res.data.data;
            } else {
              this.set_province = res.data.data;
              this.set_province1 = res.data.data;
            }
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe(text) {
      try {
        let province = text == "officail_address" ? this.data_officail_address.province : this.data_addressable.province
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${province}`).then((res) => {
          if (res.data.result == "success") {
            if (text == "officail_address") {
              this.set_amphoe1 = res.data.data;
              this.data_officail_address.zipcode = "";
              this.data_officail_address.amphur = ""
              this.data_officail_address.tambon = ""
            } else if (text == "addressable") {
              this.set_amphoe = res.data.data;
              this.data_addressable.zipcode = "";
              this.data_addressable.amphur = ""
              this.data_addressable.tambon = ""
            } else {
              this.set_amphoe1 = res.data.data;
              this.set_amphoe = res.data.data;
            }
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon(text) {
      try {
        let province = text == "officail_address" ? this.data_officail_address.province : this.data_addressable.province
        let amphur = text == "officail_address" ? this.data_officail_address.amphur : this.data_addressable.amphur
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${province}/${amphur}`).then(async (res) => {
          if (res.data.result == "success") {
            if (text == "officail_address") {
              this.set_tambon1 = res.data.data;
              this.data_officail_address.zipcode = ""
              await this.getPostal(this.data_officail_address.tambon, 'officail_address');
            } else if (text == "addressable") {
              this.set_tambon = res.data.data;
              this.data_addressable.zipcode = ""
              await this.getPostal(this.data_addressable.tambon, 'addressable');
            }
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getPostal(e, text) {
      var postal = ''
      if (text == "officail_address") {
        postal = await this.set_tambon1.find((ele) => {
          return ele.tambon === e;
        });
      } else if (text == "addressable") {
        postal = await this.set_tambon.find((ele) => {
          return ele.tambon === e;
        });
      }

      if (postal !== undefined) {
        if (text == "officail_address") {
          this.data_officail_address.zipcode = postal.zipcode;
        } else if (text == "addressable") {
          this.data_addressable.zipcode = postal.zipcode;
        }
      } else {
        if (text == "officail_address") {
          this.data_officail_address.zipcode = "";
        } else if (text == "addressable") {
          this.data_addressable.zipcode = "";
        }
      }
    },
    sum_address(data) {
      // console.log("sum_address", data);
      var text_address = "";
      if (data.house_no !== "" && data.house_no !== undefined && data.house_no !== null) {
        text_address += "บ้านเลขที่ " + data.house_no;
      }
      if (data.moo_no !== "" && data.moo_no !== undefined && data.moo_no !== null) {
        text_address += " หมู่ที่ " + data.moo_no;
      }

      if (data.soi !== "" && data.soi !== undefined && data.soi !== null) {
        text_address += " ถนน/ซอย " + data.soi;
      }

      if (data.tambon !== "" && data.tambon !== undefined && data.tambon !== null) {
        text_address += " ตำบล/แขวง " + data.tambon;
      }

      if (data.amphur !== "" && data.amphur !== undefined && data.amphur !== null) {
        text_address += " อำเภอ/เขต " + data.amphur;
      }

      if (data.province !== "" && data.province !== undefined && data.province !== null) {
        text_address += " จังหวัด " + data.province;
      }

      if (data.zipcode !== "" && data.zipcode !== undefined && data.zipcode !== null) {
        text_address += " รหัสไปรษณีย์ " + data.zipcode;
      }

      if (text_address == "") {
        return "";
      } else {
        return text_address;
      }
    },
    validateSpaceBar: (event) => {
      const input = event.target.value;
      const keyCode = event.keyCode;

      if (keyCode === 32) {
        if (input === "" || input.slice(-1) === " ") {
          event.preventDefault();
        }
      }
    }
  }
}
</script>

<style scoped>
.text_start {
  text-align: start;
  padding-bottom: 0px;
  justify-self: center;
  align-self: start;

}

.text_checkbox {
  align-self: start !important;
}

.text_name {
  text-align: end;
  padding-bottom: 0px;
  justify-self: center;
  align-self: center;
}

::v-deep .v-input--selection-controls__input+.v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #00A99D !important;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-input--selection-controls__input+.v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 8px;
  align-self: start !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41;
}

::v-deep .v-input--is-disabled>.v-input__control>.v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog>.v-card>.v-card__text {
  padding: 0px;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep .v-text-field.v-text-field--solo.v-input--dense .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #313b41 !important;
}

::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}

::v-deep .set-checkbox .v-input--selection-controls__input {
  align-self: start !important;
}
</style>